import { InfoCircled, StatusAvailable, View } from "@/assets/icons";
import { Checkbox, Row, Tooltip } from "@/components";
import clsx from "clsx";
import { FC, useRef } from "react";
import styles from "../../styles.scss";
import { TableRowProps } from "../../types";
import {
  getWorkerOnboardingStatus,
  splitBracketedComments,
} from "@/pages/requests/components/users/utils";

export const TableRow: FC<TableRowProps> = ({
  item,
  isCheckedUser,
  isInbox,
  onToggleSelectUser,
  onToggleUserModal,
}) => {
  const portalRef = useRef<HTMLDivElement>(null);

  const onboardingComments = item.WorkerOnboardingStatusComments;

  return (
    <Row
      className={clsx(
        styles.tableRow,
        !item.WorkerOnboardingStatus && styles.isDisabled,
        isInbox ? styles.col6 : styles.col7,
      )}
      style={{
        gridTemplateColumns: isInbox
          ? "repeat(5, 1fr) 65px"
          : "48px repeat(7, 1fr) 65px",
        padding: isInbox ? "0 1rem;" : "0",
      }}
    >
      {!isInbox && (
        <div className={styles.col}>
          <div className={clsx(styles.cell, styles.cellCheckbox)}>
            <Checkbox
              id={item.WorkerEidUnifiedNumber}
              name={item.WorkerEidUnifiedNumber}
              checked={!!isCheckedUser?.WorkerEidUnifiedNumber}
              className={styles.checkbox}
              onChange={e => onToggleSelectUser(item, e.target.checked)}
              disabled={!item.WorkerOnboardingStatus}
            />
          </div>
        </div>
      )}

      <div className={styles.col}>
        <div className={styles.cell} title={item.WorkerEidUnifiedNumber}>
          {item.WorkerEidUnifiedNumber}
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.cell} title={item.WorkerFirstName}>
          {item.WorkerFirstName}
        </div>
      </div>
      {!isInbox && (
        <div className={styles.col}>
          <div className={styles.cell} title={item.WorkerFullNameArabic}>
            {item.WorkerFullNameArabic}
          </div>
        </div>
      )}

      <div className={styles.col}>
        <div className={styles.cell} title={item.WorkerNationality}>
          {item.WorkerNationalityEnglish}
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.cell} title={item.WorkerJobTitle}>
          {item.WorkerJobTitle}
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.cell} title={item.WorkerEmiratesId}>
          {item.WorkerEmiratesId}
        </div>
      </div>

      {!isInbox && (
        <div className={styles.col}>
          <div className={styles.cell} title={item.WorkerPassportNumber}>
            {item.WorkerPassportNumber}
          </div>
        </div>
      )}

      <div className={clsx(styles.col, styles.colAction)}>
        <div
          className={styles.cell}
          style={{
            flexDirection: "row",
            display: "flex",
            gap: "0.5rem",
          }}
          ref={portalRef}
        >
          <div
            className={styles.actionButtonWrap}
            style={{ position: "relative" }}
          >
            <Tooltip
              portalRef={portalRef}
              title={
                <div className={styles.statusTooltip}>
                  <div>
                    Onboarding Status:{" "}
                    {getWorkerOnboardingStatus(item.WorkerOnboardingStatus)}
                  </div>
                  {!!onboardingComments && (
                    <div>
                      <div>Onboarding Comments:</div>
                      {splitBracketedComments(onboardingComments).map(
                        (comment, index) => (
                          <div key={index}>{comment}</div>
                        ),
                      )}
                    </div>
                  )}
                </div>
              }
            >
              {!item.WorkerOnboardingStatus ? (
                <InfoCircled
                  className={clsx(styles.actionButtonSubmit, styles.isRed)}
                />
              ) : (
                <StatusAvailable
                  className={clsx(styles.actionButtonSubmit, styles.isGreen)}
                />
              )}
            </Tooltip>
          </div>

          <div className={styles.actionButtonWrap}>
            <View
              className={styles.actionButtonSubmit}
              onClick={() => onToggleUserModal(item)}
            />
          </div>
        </div>
      </div>
    </Row>
  );
};
